export const LIST_WIDTH = Math.min(640, window.innerWidth);
export const RATIO = LIST_WIDTH / 750;
export const LIST_HEIGHT = window.innerHeight - 217 * RATIO;
